import { Sparkles } from "lucide-react";
import { Card, SectionHeader } from "../../components/lib";
import { ListRow } from "../../components/lib.overlay";
import { AI_TEAMMATES, AI_CONVERSATIONS, AI_INSIGHTS, AI_APPROVALS } from "../../mocks/aiData";

export default function AiOverview() {
  const onDuty = AI_TEAMMATES.filter((t) => t.status === "on-duty").length;
  const decisions = AI_TEAMMATES.reduce((s, t) => s + t.decisionsAssisted7d, 0);
  const conversations = AI_TEAMMATES.reduce((s, t) => s + t.conversationsToday, 0);
  const pendingApprovals = AI_APPROVALS.filter((a) => a.status === "pending").length;
  const openInsights = AI_INSIGHTS.filter((i) => !i.acted).length;

  return (
    <div className="space-y-6" data-testid="ai-overview">
      <Card testId="ai-kpis">
        <SectionHeader eyebrow="AI HQ" title="Executive team at a glance" action={<Sparkles size={14} style={{ color: "var(--ph-ai)" }}/>} />
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Teammates on duty</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-success)" }}>{onDuty}/{AI_TEAMMATES.length}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Conversations today</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{conversations}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Decisions assisted (7d)</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{decisions}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Pending approvals</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-warning)" }}>{pendingApprovals}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Open insights</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-danger)" }}>{openInsights}</div></div>
        </div>
      </Card>

      <Card padded={false} testId="ai-team-list">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}><SectionHeader eyebrow="Team" title="AI executives" /></div>
        <div className="p-2">
          {AI_TEAMMATES.map((t) => (
            <ListRow key={t.id} testId={`ai-t-${t.id}`}
              label={<span>{t.name} · <span className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>{t.title}</span></span>}
              sublabel={<>{t.primaryModule} · {t.conversationsToday} convos today · {t.decisionsAssisted7d} decisions 7d · avg conf {Math.round(t.averageConfidence*100)}%</>}
              trailing={<span className="text-[10px] uppercase tracking-[0.14em]" style={{ color: t.status === "on-duty" ? "var(--ph-success)" : t.status === "paused" ? "var(--ph-ink-muted)" : "var(--ph-ai)" }}>{t.status}</span>}
            />
          ))}
        </div>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card padded={false} testId="ai-latest-convos">
          <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}><SectionHeader eyebrow="Recent" title="Latest conversations" /></div>
          <div className="p-2">
            {AI_CONVERSATIONS.slice(0, 5).map((c) => (
              <ListRow key={c.id} testId={`ai-lc-${c.id}`} label={c.title} sublabel={<>{c.askedBy} · {c.askedRelative} · {c.messages} msgs</>} />
            ))}
          </div>
        </Card>
        <Card padded={false} testId="ai-open-insights">
          <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}><SectionHeader eyebrow="Signals" title="Open insights" /></div>
          <div className="p-2">
            {AI_INSIGHTS.filter((i) => !i.acted).map((i) => (
              <ListRow key={i.id} testId={`ai-li-${i.id}`} label={i.title} sublabel={i.detail}
                trailing={<span className="text-[10px] uppercase tracking-[0.14em]" style={{ color: i.severity === "high" ? "var(--ph-danger)" : i.severity === "medium" ? "var(--ph-warning)" : "var(--ph-ink-muted)" }}>{i.severity}</span>}
              />
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
